import { Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TourService } from '../service';

@Component({
  selector: 'fa-kt-tour-detail',
  templateUrl: './tour-detail.component.html',
  styleUrls: ['./tour-detail.component.css'],
})
export class TourDetailComponent {
  $loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  @Input() set loading(loading: boolean) {
    this.$loading.next(this.$loading.getValue() || loading);
  }
  @Input() height = 'calc(100vh - 324px)';

  constructor(public tour: TourService) {}
}
